import { useSwimlaneEventPublisher } from '../../api/useSwimlaneEventPublisher';

import { ItemsFilteredIcon } from './icons/ItemsFilteredIcon';
import {
  FooterTypography,
  StyledBox,
  StyledButtonFilled,
  StyledDiv,
  StyledDivider,
  SubtitleTypography,
  TitleTypography,
} from './StyledComponents';

export function AllItemsFiltered() {
  const publishEvent = useSwimlaneEventPublisher();

  return (
    <StyledDiv>
      <StyledBox>
        <ItemsFilteredIcon />
        <TitleTypography>No Items Match Filters</TitleTypography>
        <SubtitleTypography>
          Filters on this view are hiding all items. Try a less specific Filter
        </SubtitleTypography>
        <StyledButtonFilled
          variant="contained"
          onClick={() => publishEvent('emptyStateButtonClicked', { action: 'edit-filters' })}
        >
          Edit Filters
        </StyledButtonFilled>
        <StyledDivider variant="middle" />
        <FooterTypography>
          Need more guidance?
          <br />
          <a
            href="https://help.tempo.io/roadmaps/latest/working-with-filters"
            target="_blank"
            rel="noreferrer"
          >
            Visit the Tempo Help Center
          </a>
        </FooterTypography>
      </StyledBox>
    </StyledDiv>
  );
}
